import { Token } from 'models/token.interface';

// Helper function to get user type from token
export const getUserTypeFromToken = (token: Token | null): 'patient' | 'staff' => {
  if (!token) return 'patient'; // Default
  // Use explicit userType if available (future backend support)
  if (token.userType) return token.userType;
  // Otherwise infer from fields
  if (token.staffMemberId) return 'staff';
  return 'patient';
};
